// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '@core/models/api-response.model';

// Service
import { WebsocketService } from './websocket.service';
import { Subject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
@Injectable({
  providedIn: 'root'
})
export class PPChallengePromotionHttpService {

  static phase1Res: null;
  
  ppPhase1ResultIncoming = new Subject();
  updateSlotSessionIncoming = new Subject();
  messages$ = new Subject<any[]>();


  constructor(
    public dialog: MatDialog,
    private websocketService: WebsocketService,
    private http: HttpClient
  ) {}

  async ppChallengePromoInit(memberAccountId: number) {
    this.ppChallengePromoWebsocket(memberAccountId);
    this.ppChallengeCancelWebsocket(memberAccountId);
  }

  async updateSlotSessionInit() {
    this.updateSlotSessionWebsocket();
  }

  private ppChallengePromoWebsocket(memberAccountId: number) {
    this.websocketService
      .getChannel('pp-challenge-promo-channel.' + memberAccountId)
      .listen(`.PPChallengePromotionEvent`, (data) => {
        if (data) {
          PPChallengePromotionHttpService.phase1Res = data;
        } 
        
        this.ppPhase1ResultIncoming.next();
      });
  }

  private ppChallengeCancelWebsocket(memberAccountId: number) {
    this.websocketService
      .getChannel('pp-challenge-cancel-channel.' + memberAccountId)
      .listen(`.PPChallengeCancelEvent`, (data) => {
        if (data) {
          localStorage.removeItem('activePPChallengePromo');
        } 
      });
  }

  private updateSlotSessionWebsocket() {
    this.websocketService
      .getChannel('update-slot-session-channel')
      .listen(`.UpdateSlotSessionEvent`, (data) => {
        console.log('listen slot event');
        console.log(data);

        const userData = JSON.parse(localStorage.getItem('user_data'));
        let isUserRequired = userData && data['member_account_ids'].includes(userData['id']) ? true : false;
        let slotSession = sessionStorage.getItem('slotSession') === null ? {} : JSON.parse(sessionStorage.getItem('slotSession'));

        if (data && isUserRequired) {
          if (Object.keys(slotSession).length !== 0 && Object.keys(slotSession[data['game_provider_code']]).length !== 0) {
            slotSession[data['game_provider_code']] = {};
            sessionStorage.setItem('slotSession', JSON.stringify(slotSession));
          }
        } 
        
        this.updateSlotSessionIncoming.next();
      });
  }

   getActivePPChallengeRes(): Observable<any> {
    return this.http.get<ApiResponse>(`/promotion/activeppchallengeresult`).pipe(
      map(res => res.data)
    );
  }

  updatePPChallengeDialogSeen(data: any): Observable<any>{
    return this.http.put<ApiResponse>(`/promotion/updateppchallengeseen`, data).pipe(
      map(res => res.data)
    );
  }
}
